<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="about-us" />

    <div id="content" class="main-wrapper" style="height: auto !important;">
<article>
<h1>About Us</h1>
<p>Welcome to GB Free Apk, your trusted source for information about GB WhatsApp and other WhatsApp modifications. Our mission is to provide accurate, reliable, and up-to-date information to help users make informed decisions about using WhatsApp mods.</p>

<h2>Who We Are</h2>
<p>We are a team of technology enthusiasts who have been following the WhatsApp modding community for years. Our goal is to create a safe and informative platform where users can learn about the features, benefits, and risks associated with using modified WhatsApp applications.</p>

<h2>Our Mission</h2>
<ul>
<li>Provide accurate and unbiased information about GB WhatsApp and similar mods</li>
<li>Help users understand the differences between official WhatsApp and modified versions</li>
<li>Offer guidance on safe downloading practices</li>
<li>Keep users informed about the latest updates and security considerations</li>
</ul>

<h2>Important Notice</h2>
<p><strong>Disclaimer:</strong> This website is not affiliated with WhatsApp or Meta. GB WhatsApp and other WhatsApp modifications are developed by independent third-party developers. Using modified WhatsApp applications may violate WhatsApp's Terms of Service and could potentially result in account bans. We strongly recommend users to carefully consider the risks before using any modified application.</p>

<p>All information provided on this website is for educational purposes only. We do not host or distribute any APK files ourselves.</p>
</article>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'AboutUs',
  data() {
    return {
      pageName: 'about-us',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav
  },
  methods: {
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>